@if (item.route !=='' && ((item.displayName == 'Sign Out') ? isLoggedIn() : (item.displayName == 'Sign In') ? !isLoggedIn() : 'true' )) {
  <a
    mat-list-item class="main-nav__link"
  [ngStyle]="{'padding-left': (depth * 12) + 'px'}" class="menu-list-item fx-row fx-row-in-list-item fx-main-between fx-cross-start" (click)="onItemSelected(item)" [ngClass]="{'active': item.route ? router.isActive(item.route, true): false, 'expanded': expanded,
  'text-gray': item.route ? router.isActive(item.route, true): false}">
    @if ((!children && ((item.displayName == 'Sign Out') ? isLoggedIn() : (item.displayName == 'Sign In') ? !isLoggedIn() : 'true' ))) {
      <div class="fx-flex"  >
        <span class="v-align-middle m-10 side-list-title font-IBM" (click)="logoutHandler(item.displayName)">{{item.displayName}}</span>
      </div>
    }
    <div feFlex>
      @if ((children)) {
        <span class="v-align-middle m-10 side-list-child font-IBM">{{children.displayName}}</span>
      }
    </div>
    @if (item.children && item.children.length) {
      <span class="fx-row fx-flex">
        <span class="fx-flex"></span>
        <svg width="100%" viewBox="0 0 24 24" [ngClass]="{'rotate': expanded,'rotate-reverse': !expanded}">
          <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
          d="M5 12h14M12 5l7 7-7 7"></path>
        </svg>
      </span>
    }
  </a>
}

@if (item.route == '') {
  <a mat-list-item class="main-nav__link"
    [ngStyle]="{'padding-left': (depth * 12) + 'px'}" class="menu-list-item outside-link fx-row fx-row-in-list-item fx-main-between fx-cross-start" [href]="item.url"
    target="_blank">
    <div class="fx-flex">
      @if ((!children)) {
        <span class="v-align-middle m-10 side-list-title font-IBM">{{item.displayName}}</span>
      }
      @if (children) {
        <span class="v-align-middle m-10 side-list-child">{{children.displayName}}</span>
      }
    </div>
    @if (item.children && item.children.length) {
      <span class="fx-row fx-flex">
        <span class="fx-flex"></span>
        <svg width="100%" viewBox="0 0 24 24" [ngClass]="{'rotate': expanded,'rotate-reverse': !expanded}">
          <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
          d="M5 12h14M12 5l7 7-7 7"></path>
        </svg>
      </span>
    }
  </a>
}

@if (expanded ) {
  <div style="font-size: 20px !important;">
    @for (child of item.children; track child) {
      @if (((child.route == '/login' || child.route == '/join') ? !isLoggedIn() : 'true')) {
        <app-sidebar
          [children]="child" [item]="child" [depth]="depth+1" (click)="closeDialog(item)">
        </app-sidebar>
      }
    }
  </div>
}

